// A set of helper functions to retrieve props for more complex claim information requests
const getPurchaseInformationProps = (purchaseInformation: any) => {
  const formFields = []

  const nestedFields = purchaseInformation.nestedFields
  const readOnlyFields = ['invoiceNo', 'orderNo']
  const toRender: string[] = []

  for (const field of nestedFields) {
    const { id } = field
    const fields: any = {}
    field.fields.forEach((field: any, index: number) => {
      const { name, value } = field

      if (readOnlyFields.includes(name)) {
        fields[name] = {
          valid: true,
          value,
          readOnly: true,
        }

        if (value) toRender.push(name)

        return
      }

      fields[name] = {
        id: index,
        valid: false,
        value: null,
      }

      toRender.push(name)
    })
    const fieldToAdd = {
      id,
      valid: false,
      fields,
    }
    formFields.push(fieldToAdd)
  }

  return {
    toRender,
    optionsOverride: formFields,
    showAddReceipt: false,
    showRemoveReceipt: false,
    canDelete: false,
  }
}

// Run corresponding function based on information request type
export const propStrategies: { [key: string]: Function } = {
  purchaseInformation: getPurchaseInformationProps,
}
